import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M30 30h140l-8 26H38ZM44 68h112l-6 22H50ZM58 100h84l-8 20H66ZM72 128h56l-8 18H80ZM86 152h28l-6 18H92Z" }, null, -1)
  ]))]))
}
export default { render: render }